<template>
  <!-- <div class="classy"> -->
  <div class="container classy">
    <div class="row mt-0">
      <div class="col-2">
        <div class="sidebar-container">
          <!-- <div class="container bg-primary"> -->
          <div v-for="(link, index) in links" :key="index" class="m-0 p-0 py-2">
            <a
              @click="insertarLectura(link.id)"
              :href="'#' + link.id"
              v-smooth-scroll="{ duration: 2000 }"
            >
              <span>
                <img style="width: 1.6em; height: 1.6em" src="@/assets/Icons/dot.svg" alt />
              </span>
            </a>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import axios from 'axios'

export default {
  name: 'sidebar',
  data() {
    return {
      links: [],
      tempLinks: [],
      localRoot: null,
      currentURL: null
    }
  },
  created() {
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    this.tempLinks = this.localRoot['componentes']['header']['links']

    console.log('likes en sidebar: ' + this.links)
    this.tempLinks.forEach(element => {
      if (element.eslink === 0) {
        element.secciones.forEach(element => {
          this.links.push(element)
        })
      } else {
        this.links.push(element)
      }
    })
  },

  methods: {
    insertarLectura(titulo) {
      console.log(titulo)
      if (titulo === 'portada') return

      this.currentURL = window.location.href.split('/')
      let num = this.currentURL[this.currentURL.length - 1];
       console.log('num', num);
      let local_root = JSON.parse(window.localStorage.getItem('root'))
      let dated = local_root['detalles'][0]['fecha'].split('-')
      let mes = dated[1]
      let year = dated[0]
      console.log('año', year)
      console.log('mes', mes)
      axios
        .post('inserta_lectura.php', { titulo: titulo, mes: mes, year: year })
        .then(resp => {
          console.log(resp.data)
        })
        .catch(Error => {
          console.log(Error)
        })
    }
  }
}
</script>

<style scoped>
.sidebar-container {
  height: fit-content;
  width: 1.6em;
  border-radius: 50px;
  background-color: #15151581;
  /* left: 4em; */
}
.classy {
  position: fixed !important;
  z-index: 9999;
  width: 4em;
  right: 0.3em;
}
</style>
